import React from "react";
import { connect } from "react-redux";
import Loader from "Components/loader/Loader";
import { supportEmailAddress } from "../../config";
import PropTypes from "prop-types";
import * as resActions from "../../modules/resources";
import { displayFormattedDate } from "Utils/dateFormats";
import withAutoRefresh from "Components/withAutoRefresh";
import { capitalize } from "Utils/strings";
import { Icon, disabledDomain, settings } from "Icons/index";
import { bytesToGiB } from "Utils/bytesFormats";
import t from "Utils/translation.js";
import QboxmailApi from "../../qboxmailApi";
import { alertSuccess } from "Utils/alerts";
import _ from "lodash";

import Button from "Components/button/Button";
import ButtonBack from "Components/buttonBack/ButtonBack";
import DetailStatus from "Components/detailStatus/DetailStatus";
import DetailInfo from "Components/detailInfo/DetailInfo";
import cx from "classnames";
import s from "./Show.scss";
import BetaLabel from "Components/betaLabel/BetaLabel";

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class DomainShowScreen extends React.Component {
  constructor(props, context) {
    super(props);
    let baseURLForLinks;
    if (context.isLoggedUserAdmin()) {
      baseURLForLinks = `/customers/${props.match.params.customerCode}/domains/${props.match.params.domainCode}`;
    } else {
      baseURLForLinks = `/domains/${props.match.params.domainCode}`;
    }

    let domainCode = props.match.params.domainCode;
    if (context.getLoggedUserType() === "Postmaster") {
      domainCode = context.getLoggedUser().domain_code;
    }

    this.state = {
      baseURLForLinks,
      isMenuOpen: false,
      showInfo: this.props.isMediaMobile ? false : true,
      client: new QboxmailApi({ useCookie: true }),
      domainCode,
    };
  }

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  toggleInfo = () => {
    this.setState({ showInfo: !this.state.showInfo });
  };

  close = () => {
    this.setState({ isMenuOpen: false });
  };

  componentDidMount() {
    this.props.getDomain(this.state.domainCode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.isDomainLoading && this.props.isDomainLoading && !nextProps.domain) {
      // domain not found, redirect to 404 page
      this.props.history.push({ pathname: "/not_found" });
      return;
    }

    if (!this.props.domain && nextProps.domain && nextProps.domain.status === "ownership_check") {
      this.props.history.push({
        pathname: `/domains/${nextProps.domain.code}/ownership_check`,
      });
    }
  }

  showSettings() {
    this.props.history.push({
      pathname: `${this.state.baseURLForLinks}/settings`,
    });
  }

  showEmailAccounts() {
    this.props.history.push({
      pathname: `${this.state.baseURLForLinks}/email_accounts`,
    });
  }

  showAliasDomains() {
    this.props.history.push({
      pathname: `${this.state.baseURLForLinks}/aliases`,
    });
  }

  showAliasEmails() {
    this.props.history.push({
      pathname: `${this.state.baseURLForLinks}/alias_email_accounts`,
    });
  }

  goBack = () => {
    if (IS_APP) {
      this.props.history.goBack();
      return;
    }

    if (this.props.location.pathname.split("/").slice(-1)[0] === "settings") {
      this.props.history.push(window.location.pathname.replace("/settings", "/email_accounts"));
    } else {
      this.props.history.push(`/domains${_.get(this.props.location, "state.prevPagination", "")}`);
    }
  };

  enqueueDNSCheck = (code) => {
    this.state.client.enqueueDNSCheck(code).then(() => {
      alertSuccess(t("alert.check.DNS.success"));
    });
  };

  openDocs = () => {
    const lang = this.context.getLoggedUser().language;
    let url = `https://docs.qboxmail.com/it/configurazioni/impostazioni-record-mx`;

    if (lang !== "it") {
      url = "https://docs.qboxmail.com/en/configurations/mx-records-settings";
    }

    window.open(url, "_blank");
  };

  renderUnhealthyAlert = (code) => {
    const user = this.context.getLoggedUser();
    let showDocs = ["Admin", "Customer", "TeamMember"].includes(user.type);

    return (
      <div className={s.warningHMsg}>
        <div className={s.wrapHMsg}>
          <div className={s.textHMsg}>{t("infoMsg.unhealthy.text")}</div>
          <div className={s.descHMsg}>{t("infoMsg.unhealthy.desc")}</div>

          {showDocs && (
            <div className={cx(s.descHMsg, s.docsHMsg)}>
              {t("domainAlert.goToDocsMsg")}
              <a target="_blank" className={s.docsHLink} onClick={this.openDocs}>
                {t("domainAlert.goToDocs")}
              </a>
            </div>
          )}
        </div>
        <Button className={s.btnHMsg} color="outline" type="button" onClick={() => this.enqueueDNSCheck(code)}>
          button.verifyMX
        </Button>
      </div>
    );
  };

  renderTabs(domain) {
    const currentSection = this.props.location.pathname.split("/").slice(-1)[0];
    return (
      <div className={s.scrollTabs}>
        <div className={s.tabs}>
          <div
            className={cx(s.itemTab, { [s.active]: currentSection === "email_accounts" })}
            onClick={this.showEmailAccounts.bind(this)}
          >
            {t("tab.emailAccounts")} [{domain.no_email_accounts}]
          </div>
          <div
            className={cx(s.itemTab, { [s.active]: currentSection === "aliases" })}
            onClick={this.showAliasDomains.bind(this)}
          >
            {t("tab.aliasDomains")} [{domain.no_alias_domains}]
          </div>
          <div
            className={cx(s.itemTab, {
              [s.active]: currentSection === "alias_email_accounts",
            })}
            onClick={this.showAliasEmails.bind(this)}
          >
            {t("tab.emailAlias")} [{domain.no_alias_email_accounts}]
          </div>
          <div
            className={cx(s.itemTab, s.settingsTab, {
              [s.active]: currentSection === "settings",
            })}
            onClick={this.showSettings.bind(this)}
          >
            <Icon className={s.iconTabs} svg={settings} width="0.75rem" height="0.75rem" />
            {t("tab.settings")}
            <div className="ml-1">
              <BetaLabel fullyRounded />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { domain, isDomainLoading } = this.props;
    const { showInfo } = this.state;
    const { getLoggedUserType, isMediaMobile } = this.context;

    if (isDomainLoading) {
      return <Loader {...this.props} />;
    }

    let content;
    if (domain.status === "updating") {
      content = <Loader msg={t("infoMsg.domainUpdating")} />;
    } else if (domain.status === "failure") {
      content = (
        <div className={s.wrapFulldMsg}>
          <div className={s.wrapIllustration}>
            <Icon svg={disabledDomain} width="10rem" height="10rem" />
            <div className={s.msgIllustration}>{t("alert.domain.problem")}</div>
            <a
              href={`mailto:${supportEmailAddress}?Subject=There%20are%20problems%20with%20domain%20${domain.name}(#${domain.code})`}
              target="_top"
            >
              {supportEmailAddress}
            </a>
          </div>
        </div>
      );
    } else {
      content = React.cloneElement(this.props.children, {
        ...this.props,
      });
    }

    let path = this.props.location.pathname.split("/").slice(-1)[0];

    const hideHeader = path.match(/add/); //|| ;
    const showSettingsHeader = !!path.match(/settings/);
    return (
      <div
        className={cx(s.showDomains, {
          [s.hideHeader]: hideHeader,
          [s.showSettings]: showSettingsHeader,
          [s.notHealty]: !domain.is_healthy && !showSettingsHeader,
          [s.isPostmaster]: getLoggedUserType() === "Postmaster",
        })}
      >
        {!domain.is_healthy && !showSettingsHeader && !hideHeader && (
          <div className={s.healthyMsg}>{this.renderUnhealthyAlert(domain.code)}</div>
        )}

        {!hideHeader && (
          <div className={s.navigation}>
            {getLoggedUserType() !== "Postmaster" ? <ButtonBack onClick={this.goBack} /> : <div />}
            <div className={s.viewSectionLabel}>
              {showSettingsHeader ? t("section.view.domain.settings") : t("section.view.domain")}
            </div>
          </div>
        )}

        {!hideHeader && (
          <div className={s.header}>
            <div className={s.wrapTitle}>
              <div className="sectionTitle">{domain.name}</div>

              {!showSettingsHeader && isMediaMobile() && (
                <div className={cx(s.showInfo, "internalLink")} onClick={this.toggleInfo}>
                  {showInfo ? t("button.details.hide") : t("button.details.show")}
                </div>
              )}
            </div>
            {showInfo && (
              <div className={s.subtitle}>
                {!showSettingsHeader && <DetailStatus status={domain.status} />}
                <div className="sectionDesc">{domain.company}</div>
              </div>
            )}

            {!showSettingsHeader && showInfo && (
              <div className={s.info}>
                <DetailInfo label={t("detailInfo.label.plan")} info={capitalize(domain.plan.name)} inLine />
                <DetailInfo label={t("detailInfo.label.code")} info={domain.code} inLine />
                <DetailInfo
                  label={t("detailInfo.label.created")}
                  info={domain.activated_at && displayFormattedDate(domain.activated_at)}
                  inLine
                />
                {domain.manager_code && (
                  <DetailInfo label={t("detailInfo.label.manager")} info={domain.manager_fullname} inLine />
                )}

                <DetailInfo
                  label={t("detailInfo.label.defaultQuota")}
                  info={bytesToGiB(domain.default_quota, true)}
                  inLine
                />
              </div>
            )}
          </div>
        )}

        <div className={s.settings}>
          {domain.status !== "failure" &&
            getLoggedUserType() !== "Postmaster" &&
            !showSettingsHeader &&
            this.renderTabs(domain)}

          {content}
        </div>

        {domain.status === "disabled" && (
          <div className={s.wrapFulldMsg}>
            <div className={s.illustrationMsg}>
              <Icon svg={disabledDomain} width="10rem" height="10rem" />
              <div>{t("alert.cannotEditWhileDisabled")}</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

DomainShowScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  domain: resActions.getData("domain.data", state)[0],
  isDomainLoading: resActions.isResourceLoading("domain", state),
});

const mapDispatchToProps = (dispatch) => ({
  getDomain: (code) => dispatch(resActions.callApi("getDomain", "domain", code)),
  refreshDomain: (code) => {
    dispatch(resActions.callApi("refreshDomain", "domain", code));
  },
});

const refreshConditionFunc = (props) => {
  const statuses = ["activating", "disabling", "enabling", "deleting", "updating"];
  const enqueued =
    props.domain &&
    (statuses.includes(props.domain.status) ||
      (props.domain.status === "ownership_check" && props.domain.status_detail === "verifying"));

  return enqueued && !props.isDomainLoading;
};

const onRefreshFunc = (props) => {
  props.refreshDomain(props.domain.code);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withAutoRefresh(DomainShowScreen, refreshConditionFunc, onRefreshFunc));
